import {
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Badge,
  Card,
  CardBody,
  Button,
  Spinner,
} from "reactstrap";
import React from "react";
import { useTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";
import { AIModelDto, SubjectDocumentDto } from "../../interfaces";

type TProps = {
  subjectDocument: SubjectDocumentDto | undefined | null;
  show: boolean;
  onCloseClick: (event: any) => void;
  onRefresh: () => void;
  loading: boolean;
};

export const SubjectAIModelsModal: React.FC<TProps> = ({
  subjectDocument,
  show,
  onCloseClick,
  onRefresh,
  loading,
}) => {
  const { t, i18n } = useTranslation();

  const onClose = () => {
    onCloseClick(!show);
  };

  const getStatusColor = (status?: string) => {
    switch (status?.toLowerCase()) {
      case "ready":
        return "success";
      case "processing":
        return "info";
      case "pending":
        return "warning";
      case "failed":
        return "danger";
      default:
        return "secondary";
    }
  };

  return (
    <React.Fragment>
      <Modal size="lg" isOpen={show} toggle={onClose} centered>
        <ModalHeader toggle={onClose} className="fw-semibold">
          {t("aiModels")} {`(${subjectDocument?.models.length || 0})`}
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col className="d-flex justify-content-end">
              <Button color="success" onClick={onRefresh}>
                {loading ? <Spinner size={"sm"} /> : t("refresh")}
              </Button>
            </Col>
          </Row>
          <Row>
            {subjectDocument?.models.map((model: AIModelDto, index: number) => (
              <Col lg={4} md={6} sm={12} key={index} className="mb-3">
                <Card className="shadow-sm border-0 h-100 text-center">
                  <CardBody>
                    <h5 className="fw-bold mb-2">
                      {(i18n.language === "ar"
                        ? model.label?.ar
                        : model.label?.en) || "-"}
                    </h5>

                    <p className="text-muted small mb-3">
                      {(i18n.language === "ar"
                        ? model.description?.ar
                        : model.description?.en) || "-"}
                    </p>

                    <div className="mb-2">
                      <span className="fw-semibold">Version:</span>{" "}
                      <span className="text-dark">{model.version}</span>
                    </div>

                    <Badge
                      color={getStatusColor(model.status)}
                      className="px-3 py-2 text-uppercase fw-semibold"
                    >
                      {model.status}
                    </Badge>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};
